import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import Link from '../Link'

const RouterLink = (props) => <Link as={ReactRouterLink} {...props} />

export default RouterLink
